import { render, staticRenderFns } from "./TrueFalseQuestion.vue?vue&type=template&id=154594c0"
import script from "./TrueFalseQuestion.vue?vue&type=script&lang=js"
export * from "./TrueFalseQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports